// extracted by mini-css-extract-plugin
export var postsContainer = "blog-module--postsContainer--3xiCh";
export var post = "blog-module--post--2yM5f";
export var separator = "blog-module--separator--2FDCv";
export var categoryBulletLists = "blog-module--categoryBulletLists--1A_wy";
export var categoryBulletItemActive = "blog-module--categoryBulletItemActive--3hupn";
export var categoryBulletItemNotActive = "blog-module--categoryBulletItemNotActive--1xwXE";
export var categoryContainer = "blog-module--categoryContainer--1usLZ";
export var categoryTitle = "blog-module--categoryTitle--3RiFn";
export var postsContainerTitle = "blog-module--postsContainerTitle--3yM9f";
export var title = "blog-module--title--3I99E";
export var date = "blog-module--date--31TvZ";
export var excerpt = "blog-module--excerpt--1kAL-";
export var categoryItem = "blog-module--categoryItem--2AAhh";
export var categoryItemNotFirst = "blog-module--categoryItemNotFirst--2Xa-K";